import style from './style.module.css';

export default function Image({ src, alt }) {
	return (
		<section class={style.imageContainer}>
			<img
				class={style.image}
				src={src}
				alt={alt}
			/>
		</section>
	);

}
